module.exports = __webpack_public_path__ + "static/img/logo.f245b09c.png";